import Vue from "vue";
import { ActionTree } from "vuex";
import { RootState } from "@/types";
import {
  ICompanyImageUpdateRequest,
  CompanyImageState,
  ICompanyImage
} from "@/types/company_image";
import axios from "axios";

export const actions: ActionTree<CompanyImageState, RootState> = {
  async getList({ commit }, company_id: number) {
    try {
      const response = await axios.get<ICompanyImage[]>(
        `/company/${company_id}/image`
      );

      commit("list", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async adminUpdate({ commit }, params: ICompanyImageUpdateRequest) {
    try {
      const response = await axios.post<ICompanyImage>(
        `/admin/company-image`,
        params
      );

      commit("list", response.data);
      commit("error/resetError", null, { root: true });
      Vue.prototype.$flashStorage.flash("更新完了", "success", {
        timeout: 3000,
        important: true
      });
      return true;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
      Vue.prototype.$flashStorage.flash(
        "更新失敗:後ほど再度お試しください",
        "error",
        {
          timeout: 3000,
          important: true
        }
      );
      return false;
    }
  },
  async adminGet({ commit }, company_id: number) {
    try {
      const response = await axios.get<ICompanyImage>(
        `/admin/company/${company_id}/image`
      );

      commit("single", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },

  async adminGetList({ commit }, company_id: number) {
    try {
      const response = await axios.get<ICompanyImage[]>(
        `/admin/company/${company_id}/image`
      );

      commit("list", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async delete({ commit }, company_image_id: number) {
    try {
      await axios.delete(`/image/${company_image_id}`);
      Vue.prototype.$flashStorage.flash("削除完了", "success", {
        timeout: 3000,
        important: true
      });
      commit("error/resetError", null, { root: true });
      commit("remove", company_image_id);

      return true;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
      Vue.prototype.$flashStorage.flash("削除失敗", "error", {
        timeout: 3000,
        important: true
      });

      return false;
    }
  }
};

export default actions;
